import script from "./ChannelsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelsModal.vue?vue&type=script&setup=true&lang=js"

import "./ChannelsModal.vue?vue&type=style&index=0&id=8991b01c&scoped=true&lang=css"

import exportComponent from "/var/www/html/a4m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8991b01c"]])

export default __exports__